import { render, staticRenderFns } from "./MessageGroup.vue?vue&type=template&id=2e5b4cd1&"
import script from "./MessageGroup.vue?vue&type=script&lang=js&"
export * from "./MessageGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports